export class TogglesClass {
  SortTimeDescending: boolean;
  ShowAccessLocks: boolean;
  ShowMail: boolean;
  ShowData: boolean;
  ShowAssignments: boolean;
  ShowEvents: boolean;
  ShowDesignations: boolean;
  ShowOther: boolean;
  ShowMilliseconds: boolean;

  constructor() {
    this.SortTimeDescending = false;
    this.ShowAccessLocks = false;
    this.ShowMail = false;
    this.ShowData = false;
    this.ShowAssignments = false;
    this.ShowEvents = false;
    this.ShowDesignations = false;
    this.ShowOther = false;
    this.ShowMilliseconds = false;
  }
}
